import { HttpErrorResponse } from '@angular/common/http';
import { extractApiError, getDeepestMessage } from './api-error.utils';

export interface ErrorReportContext {
  readonly user: string;
  readonly route: string;
  readonly browser: string;
  readonly time: string;
}

export interface HttpErrorRequestInfo {
  readonly method: string;
  readonly url: string;
}

export const buildReportContext = (
  user: string,
  time: string
): ErrorReportContext => ({
  user,
  route: globalThis.location.pathname + globalThis.location.search,
  browser: globalThis.navigator.userAgent,
  time,
});

export const buildHttpErrorReport = (
  error: HttpErrorResponse,
  request: HttpErrorRequestInfo,
  context: ErrorReportContext
): string => {
  const apiError = extractApiError(error);
  return JSON.stringify(
    {
      kind: 'http',
      status: error.status,
      method: request.method,
      requestUrl: request.url,
      code: apiError?.code ?? null,
      message: apiError ? getDeepestMessage(apiError) : error.message,
      serverTime: apiError?.serverTimestamp ?? null,
      route: context.route,
      browser: context.browser,
      user: context.user,
      time: context.time,
    },
    null,
    2
  );
};

export const buildRuntimeErrorReport = (
  error: unknown,
  context: ErrorReportContext
): string => {
  const runtimeError = error instanceof Error ? error : undefined;
  return JSON.stringify(
    {
      kind: 'runtime',
      error: runtimeError
        ? `${runtimeError.name}: ${runtimeError.message}`
        : String(error),
      stack: runtimeError?.stack ?? null,
      route: context.route,
      browser: context.browser,
      user: context.user,
      time: context.time,
    },
    null,
    2
  );
};
